// Shared constants for alert subscriptions and report alert forms.

// Using upper case values here to match the value from selectedRule to avoid console warnings
// The LLM returns the value capitalized
export const SEVERITY_OPTIONS = [
	{ label: 'Info', value: 'Info' },
	{ label: 'Warning', value: 'Warning' },
	{ label: 'Critical', value: 'Critical' },
];

export const SEVERITY_COLOR_MAP = {
	critical: 'signal.red',
	warning: 'signal.amber',
	info: 'signal.blue',
};

export const VISIBILITY_OPTIONS = [{ label: 'Personal', value: 'local' }];

export const TENANT_ADMIN_VISIBILITY_OPTIONS = [
	{ label: 'Personal', value: 'local' },
	{ label: 'Global', value: 'global' },
];

export const COMPARISON_OPTIONS = [
	{ value: 'gt', label: 'Greater than' },
	{ value: 'lt', label: 'Less than' },
	{ value: 'gte', label: 'Greater than or equal to' },
	{ value: 'lte', label: 'Less than or equal to' },
	{ value: 'eq', label: 'Equal to' },
];
